import classnames from 'classnames'
import Text from 'src/Components/shared/Text'
import styles from './BotHeadSpinWithMessage.module.scss'
import Lottie from 'react-lottie'
import animationData from '../../../../assets/lotties/botheadspin.json'

interface BotHeadSpinWithMessageProps {
  className?: string
  children: React.ReactNode // usually a <FormattedMessage/>
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

export const BotHeadSpinWithMessage = ({
  className,
  children,
}: BotHeadSpinWithMessageProps) => (
  <div className={classnames(styles.root, className)}>
    <Lottie
      isClickToPauseDisabled={true}
      options={defaultOptions}
      height={70}
      width={70}
    />
    <Text
      className={styles.message}
      variant='white'
      size='xl'
      align='center'
      element='div'
    >
      {children}
    </Text>
  </div>
)
